import { render, staticRenderFns } from "./CodeMirror.vue?vue&type=template&id=a80aa98c"
import script from "./CodeMirror.vue?vue&type=script&lang=js"
export * from "./CodeMirror.vue?vue&type=script&lang=js"
import style0 from "./CodeMirror.vue?vue&type=style&index=0&id=a80aa98c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports